/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";

import Card from "@mui/material/Card";
import { formatDate, formatCurrency } from "utils";
import SoftBox from "components/SoftBox";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import DataTable from "./DataTable";
import ActionCell from "./components/ActionCell/index";
import { ValueAddedTaxFilingService } from "services/value-added-tax-filing";

const renderData = (items, setDataTable) => {
  return items.map((item) => {
    const docDateObj =
      item.items && item.items[0] && item.items[0].documentDate
        ? new Date(item.items[0].documentDate)
        : null;
    const docDate = docDateObj ? docDateObj.toLocaleDateString("vi-VN") : "";

    return {
      id: item._id,
      documentNumber: item.documentNumber || item.code || "",
      docDate,
      company: item.company?.name || "N/A",
      totalPaidVatAmount:
        item.items?.reduce((sum, it) => sum + (parseFloat(it.paidVatAmount) || 0), 0) || 0,
      totalPayableVatAmount: formatCurrency.format(
        item.items?.reduce((sum, it) => sum + (parseFloat(it.payableVatAmount) || 0), 0) || 0
      ),
      createdAt: formatDate(item.createdAt),
      action: <ActionCell item={item} setDataTable={setDataTable} />,
    };
  });
};

const tableData = {
  columns: [
    {
      Header: "Ngày tạo",
      accessor: "createdAt",
    },
    {
      Header: "Tổng thuế GTGT đã nộp",
      accessor: "totalPaidVatAmount",
      width: "20%",
    },
    {
      Header: "Tổng thuế GTGT phải nộp",
      accessor: "totalPayableVatAmount",
      width: "20%",
    },
    { Header: "Thao tác", accessor: "action", sorted: false },
  ],
  rows: [],
};

function ValueAddedTaxFiling() {
  const [loading, setLoading] = useState(false);
  const [dataTable, setDataTable] = useState(tableData);
  const [query, setQuery] = useState({ sortBy: "createdAt", sortType: "desc" });
  const [checkCreate, setCheckCreate] = useState(true);
  const [paginationData, setPaginationData] = useState({
    page: 1,
    count: 0,
    size: 10,
  });

  useEffect(() => {
    fetchData();
  }, [query, paginationData.page]);

  const fetchData = async () => {
    try {
      setLoading(true);

      const response = await ValueAddedTaxFilingService.getPaginate({
        ...query,
        page: paginationData.page,
        size: paginationData.size,
      });

      const { items, checkCreate: createPerm, paginate } = response.data || response;
      setCheckCreate(createPerm ? false : true);
      setPaginationData((prev) => ({
        ...prev,
        count: paginate?.count || 0,
        size: paginate?.size || 10,
      }));

      setDataTable((prev) => ({
        ...prev,
        rows: renderData(items || [], setDataTable),
      }));

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Lỗi lấy dữ liệu Sổ Chi Tiết Thuế GTGT Được Hoàn Lại:", error);
      setDataTable((prev) => ({ ...prev, rows: [] }));
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox my={3}>
        <Card style={{ height: "100%" }}>
          <DataTable
            checkCreate={checkCreate}
            query={query}
            table={dataTable}
            loading={loading}
            setQuery={setQuery}
            paginationData={paginationData}
            setPaginationData={setPaginationData}
          />
        </Card>
      </SoftBox>
    </DashboardLayout>
  );
}

export default ValueAddedTaxFiling;
